import {
  REQUEST_SETTLEMENTS,
  RECEIVE_SETTLEMENTS,
  HIDE_TEMPORARY_SETTLEMENT_BANNER,
} from './types';

export default function (
  state = {
    isFetchingSettlements: false,
    response: null,
    temporaryShowSettlementBanner: true,
  },
  action
) {
  switch (action.type) {
    case HIDE_TEMPORARY_SETTLEMENT_BANNER:
      return {
        ...state,
        temporaryShowSettlementBanner: action.temporaryShowSettlementBanner,
      };
    case REQUEST_SETTLEMENTS:
      return { ...state, isFetchingSettlements: true };
    case RECEIVE_SETTLEMENTS:
      return {
        ...state,
        isFetchingSettlements: false,
        response: action.payload,
      };
    default:
      return state;
  }
}
